import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import Swal from "sweetalert2";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import queryString from "query-string";

import Grid from "@material-ui/core/Grid";
import { ValidatorForm } from "react-material-ui-form-validator";
import MaterialTable from "material-table";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Search from "@material-ui/icons/Search";
import GetApp from "@material-ui/icons/GetApp";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import config from "../../../../config";
import * as Table from "../../../../config/tableConfig";

import { BoxSendEmail } from "./styles";
import { Container, IButton, StatusColor } from "../../../../styles/styles";

import { getKeyByValue, dateCurrent, downloadDocument, statusStringFilter } from "../../../../utils";

import {
  DocumentsToGet,
  DocumentStatusType,
  DocumentEmailToPost,
  DocumentMissingEmailToPost,
  Document_DocumentTypesToGet,
  SendEmailToPost,
} from "../../models/interfaces";
import { Provider } from "../../../provider/models/interfaces";
import { EmailConfigToGet } from "../../../email/models/interfaces";

import { AppState } from "../../../../store/";

import { getDocumentsTypes } from "../../../document-type/store/actions";
import { getProviders } from "../../../provider/store/actions";
import {
  getDocuments,
  deleteDocument,
  sendEmail,
  sendEmailDocumentMissing,
  gatDocumentsMissing,
  getEmailConfig,
} from "../../store/actions";

const INITIAL_DocumentSendEmail: DocumentEmailToPost = {
  subject: "",
  body: "",
  providerDocumentIds: [],
};

const INITIAL_EmailCharge: SendEmailToPost = {
  subject: "",
  body: "",
};

const INITIAL_DocumentMissingSendEmail: DocumentMissingEmailToPost = {
  subject: "",
  body: "",
  providerIds: [],
  providerDocumentMissing: [],
};

const statusNumber = (status: string | string[] | null | undefined): string => {
  switch (status) {
    case "PendenteFornecedor":
      return "0";
    case "Aprovado":
      return "1";
    case "Vencido":
      return "2";
    case "Reprovado":
      return "3";
    case "PendenteCentral":
      return "4";
    case "Faltantes":
      return "5";
    default:
      return "99";
  }
};

const DocumentList: React.FC = (props: any) => {
  const params = queryString.parse(props.location.search);
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const [OpenModalDemand, setOpenModalDemand] = useState(false);
  const [RenderList, setRenderList] = useState(false);
  const [providerFilterInput, setProviderFilterInput] = useState("");
  const [filterStatus, setFilterStatus] = useState(statusNumber(params?.status));
  const [providerFilter, setProviderFilter] = useState(0);
  const [listDocuments, setListDocuments] = useState<DocumentsToGet[]>([]);
  const [page] = useState<number | null>(null);
  const [typesFilter, setTypesFilter] = useState<Document_DocumentTypesToGet[]>([]);
  const [checksTypesFilter, setChecksTypesFilter] = useState("");

  const [DocumentSendEmail, setDocumentSendEmail] = useState<DocumentEmailToPost>(INITIAL_DocumentSendEmail);
  const [DocumentMissingSendEmail, setDocumentMissingSendEmail] = useState<DocumentMissingEmailToPost>(INITIAL_DocumentMissingSendEmail);
  const [emailCharge, setEmailCharge] = useState<SendEmailToPost>(INITIAL_EmailCharge);

  const listDocumentsBkp: DocumentsToGet[] = useSelector((state: AppState) => state.Document.listDocuments);
  const listDocumentsMissing: DocumentsToGet[] = useSelector((state: AppState) => state.Document.listDocumentsMissing);

  const listProviders: Provider[] = useSelector((state: AppState) => state.Provider.listProviders);
  const listDocumentTypes: Document_DocumentTypesToGet[] = useSelector((state: AppState) => state.DocumentType.listDocumentTypes);

  const authType: string = useSelector((state: AppState) => state.Authorization.authType);
  const isLoading = useSelector((state: AppState) => state.Document.isLoading);
  const isLoadingDocumentType = useSelector((state: AppState) => state.DocumentType.isLoading);

  const history = useHistory();
  const { providerId: id } = useParams<{providerId: string}>();

  useEffect(() => {
    getDocumentsTypes();
    getDocuments(id, page);
    emailConfig(false);
  }, [id, page]);


  useEffect(() => setListDocuments(listDocumentsBkp), [listDocumentsBkp]);
  useEffect(() => setListDocuments(listDocumentsMissing), [listDocumentsMissing]);

  useEffect(() => {
    setEmailsSubjectBody()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailCharge]);


  useEffect(() => {
    const debounce = setTimeout(() => {
      let providerFilter = providerFilterInput;

      if (providerFilter) getProviders(providerFilter.trim())

    }, 600);

    return () => clearTimeout(debounce);

  }, [providerFilterInput]);

  useEffect(() => {

    (async () => {
      let status = await statusStringFilter(filterStatus);

      if (status.toLocaleLowerCase() !== "faltantes") return;

      if (providerFilter !== 0) return await gatDocumentsMissing(providerFilter);

      if (id) return await gatDocumentsMissing(id === "all" ? 0 : Number(id));

    })();

  }, [providerFilter, filterStatus, id]);

  useEffect(() => {

    (async () => {
      const status = (await statusStringFilter(filterStatus)).toLocaleLowerCase();

      const documents = status === "faltantes" ? listDocumentsMissing : listDocumentsBkp;

      await filterDocuments(providerFilter, checksTypesFilter, status, documents);

    })();

  }, [providerFilter, checksTypesFilter, filterStatus, listDocumentsMissing, listDocumentsBkp,
  ]);

  const emailConfig = async (openDialog: boolean) => {

    await getEmailConfig().then((response: EmailConfigToGet) => {
      setEmailCharge({
        subject: response?.subjectChargeDefault,
        body: response?.messageChargeDefault
      });

    }).catch(err => {

      Swal.fire({
        title: 'Erro',
        text: `Ocorreu algum erro ao carregar os dados. Detalhes: ${err}`,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000
      });

    });

    if (openDialog) {
      setOpenModalDemand(true);
    }
  };

  const setEmailsSubjectBody = async () => {

    setDocumentSendEmail({
      ...DocumentSendEmail,
      subject: emailCharge?.subject,
      body: emailCharge?.body
    });

    setDocumentMissingSendEmail({
      ...DocumentMissingSendEmail,
      subject: emailCharge?.subject,
      body: emailCharge?.body
    });

  };

  const filterDocuments = async (providerId: number | 0, checksTypes: string | "todos", status: string, documents: DocumentsToGet[]) => {
    let documentsBkp: DocumentsToGet[] = [];
    let documentsAux: DocumentsToGet[] = [];

    if (providerId !== 0) documents = documents.filter((document) => document?.providerId === providerId);

    if (checksTypes !== "") checksTypes = checksTypes.toLocaleLowerCase();

    const types: string[] = checksTypes ? checksTypes.split(",") : [];
    if (types && types.indexOf("todos") === -1) {
      let cont: number = 0;

      types.forEach((type) => {
        documentsBkp = documents.filter((document) => document?.typeDocumentName?.toString().toLocaleLowerCase() === type);
        documentsAux = [...documentsAux, ...documentsBkp];
        cont++;
      });

      if (cont > 0) documents = documentsAux;

    }

    if (status !== "todos" && status !== "faltantes") {
      documents = documents.filter((document) => document?.status.toString().toLocaleLowerCase() === status);
    }

    setListDocuments(documents);
  };

  const handleOpenModalDemand = () => {emailConfig(true);}
  const handleCloseModalDemand = () => setOpenModalDemand(false);
  const handleSubmitFilter = async (event: React.ChangeEvent<HTMLSelectElement>) => event.preventDefault();

  const handleOnChangeFilterProvider = async (_: any, newEvent: any) => {
    const provider = JSON.stringify(newEvent, null, " ");

    if (provider) return setProviderFilter(JSON.parse(provider)?.id || 0);

    return setProviderFilter(0);
  };

  const handleSubmit = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();

    await setEmailsSubjectBody();

    console.log("DocumentSendEmail = ", DocumentSendEmail)
    console.log("DocumentMissingSendEmail = ", DocumentMissingSendEmail)
    if (DocumentSendEmail || DocumentMissingSendEmail) {
      Swal.fire({
        title: "",
        html: "Você tem certeza que deseja enviar essa mensagem?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      }).then((res: any) => {

        if (!res.value) return

        Swal.fire({
          title: "Aguarde...",
          text: "Enviando E-Mail",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,

          didOpen: async () => {
            Swal.showLoading();

            const response = filterStatus === "5" ?
              await sendEmailDocumentMissing(DocumentMissingSendEmail) : await sendEmail(DocumentSendEmail);

            if (response) {
              Swal.fire(
                "Enviado",
                "A mensagem dos documentos foi enviada para os fornecedores com sucesso!",
                "success"
              );

              setDocumentSendEmail(INITIAL_DocumentSendEmail);
              setDocumentMissingSendEmail(INITIAL_DocumentMissingSendEmail);

              listDocuments.forEach((d) => { if (d.tableData) d.tableData.checked = false });
              setRenderList(!RenderList);
              handleCloseModalDemand();
              return
            }

            return Swal.fire({
              title: "Erro",
              text: `Ocorreu algum erro ao executar a ação!`,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
            });

          },
        });
      });
    }
  };

  const deleteConfirmation = (id: number) => {
    Swal.fire({
      title: "Confirmação",
      html: "Você tem certeza que deseja remover esse documento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar"

    }).then((res: any) => {
      if (!res.value) return

      Swal.fire({
        title: "Aguarde...",
        text: "Removendo Documento",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,

        didOpen: async () => {
          Swal.showLoading();

          const response = await deleteDocument(id);
          if (response) {
            return Swal.fire(
              "Removido",
              "O Documento foi removido com sucesso !",
              "success"
            );
          }

          return Swal.fire({
            title: "Erro",
            text: `Ocorreu algum erro ao executar a ação!`,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });

        },
      });

    });
  };


  const handleFilterStatusDocuments = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value) {
      if (filterStatus === "5") getDocuments(id, page);

      setFilterStatus(event.target.value);
    }
  };


  const handleDocumentChecked = (e: any[]) => {
    const providerIds: number[] = id === 'all' ? e.map((element) => element.id) : [parseInt(id)]
    console.log("providerIds = ", providerIds)
    if (filterStatus === "5") {
      const DocumentsToPostEmail = e.map((element) => {
        return {
          id: element.id,
          documentTypeId: element.documentTypeId,
          providerId: element.providerId,
        };
      });

      return setDocumentMissingSendEmail({
        ...DocumentMissingSendEmail,
        providerIds: providerIds,
        providerDocumentMissing: DocumentsToPostEmail,
      });
    }

    if (id === 'all' || providerIds.length > 0) {
      return setDocumentSendEmail({
        subject: DocumentSendEmail.subject,
        body: DocumentSendEmail.body,
        providerDocumentIds: providerIds
      });
    }

    return setDocumentSendEmail({
      subject: DocumentSendEmail.subject,
      body: DocumentSendEmail.body,
      providerDocumentIds: [],
      providerId: parseInt(id),
    });

  };

  const handleChangePage = (_: any) => {
    // setPage(parseInt(page))
  };

  const handleChangeTypeFilter = (event: React.ChangeEvent<{ value: unknown }>) => {
    const types = event.target.value as Document_DocumentTypesToGet[];

    setChecksTypesFilter(types.toString());
    setTypesFilter(types);
  };

  const validPermissionActions = async (status: string) => {
    return authType === config.userTypeAdmin || status === "PendenteFornecedor" ||
      status === "Reprovado" || status === "Vencido" ?
      true : false;
  };

  const editDocument = async (rowDataId: number | 0, status: string) => {
    if (!(await validPermissionActions(status))) {
      return Swal.fire({
        title: "Ops",
        html: "Seu perfil não possui permissão para editar o arquivo.",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    }

    return history.push(`/document${id ? "/" + id : ""}/edit/${rowDataId}`);
  };

  const exportToExcel = (csvData: any, fileName: string) => {
    csvData = csvData.map((element: DocumentsToGet) => {
      return {
        Nome: element.description,
        "Tipo de Documento": element.documentType?.name,
        "Data de Envio": element.creationDate ? dateCurrent("pt-BR", element.creationDate.toString()) : "",
        "Data de Vencimento": element.expirationDate ? dateCurrent("pt-BR", element.expirationDate.toString()) : "",
        Status: element.status,
      };
    });

    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `${fileName}${fileExtension}`);
  };

  const renderListDocument = useMemo(() =>
  (<MaterialTable
    title=""
    localization={Table.Localization}
    onChangePage={(_: any, page: any) => handleChangePage(page)}
    options={Object.assign(Table.Options, {
      pageSizeOptions: [5, 10],
      // pageSize:totaldocuments,
      selection: (!!id && authType === config.userTypeAdmin) ?? false,
      exportAllData: true,
      exportButton: authType === config.userTypeAdmin ?? false,
      exportCsv: (_: any, renderData: any) => {
        var dt = new Date();
        var ms = dt.getMilliseconds();
        exportToExcel(
          renderData,
          "ListadeDocumentos" +
          dateCurrent("en-US").split("-").join("") +
          ms.toString()
        );
      },
    })}
    onSelectionChange={(data: any) => handleDocumentChecked(data)}
    icons={Table.Icons}
    columns={[
      {
        title: "Tipo de Documento",
        field: "typeDocumentName",
      },
      {
        title: "Descrição",
        field: "description",
      },
      {
        title: "Fornecedor",
        field: "providerName",
      },
      {
        title: "Data de Envio",
        field: "creationDate",
        type: "date",
        defaultSort: "desc",
      },
      {
        title: "Data de Validade",
        field: "expirationDate",
        type: "date",
      },
      {
        title: "Status",
        field: "status",
        render: (rowData: any) => {
          return <StatusColor status={rowData.status} />;
        },
      },
    ]}
    actions={[
      {
        position: "row",
        tooltip: "Baixar Arquivo",
        icon: () => <GetApp />,
        onClick: (_: any, rowData: any) =>
          downloadDocument(rowData.path, rowData.id),
        disabled: filterStatus === "5" ?? true,
      },
      {
        position: "row",
        tooltip: "Editar",
        icon: () => <Edit />,
        onClick: (_: any, rowData: any) =>
          editDocument(parseInt(rowData?.id), rowData?.status.toString()),
        disabled: filterStatus === "5" ?? true,
      },
      {
        position: "row",
        tooltip: "Visualizar",
        icon: () => <Search />,
        onClick: (_: any, rowData: any) =>
          history.push(`/document${id ? "/" + id : ""}/detail/${rowData.id}`),
        disabled: filterStatus === "5" ?? true,
      },
      {
        position: "row",
        tooltip: "Remover",
        icon: () => <Delete />,
        onClick: (_: any, rowData: any) => deleteConfirmation(rowData.id),
        disabled: filterStatus === "5" ?? true,
      },
    ]}
    data={listDocuments.map((element) => {
      element.status = getKeyByValue(DocumentStatusType, element.status);
      return element;
    })}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  />), [id, listDocuments])

  const ButtonCobrar = () => {

    if (filterStatus === "5") {
      if (DocumentMissingSendEmail?.providerDocumentMissing?.length > 0) {
        return (
          <IButton
            width={110}
            background="orange"
            type="button"
            onClick={handleOpenModalDemand}
          >
            COBRAR
          </IButton>
        );
      }
      return
    }

    if (DocumentSendEmail?.providerDocumentIds?.length > 0) {
      return (
        <IButton
          width={110}
          background="orange"
          type="button"
          onClick={handleOpenModalDemand}
        >
          COBRAR
        </IButton>
      );
    }

  };

  return (  
    <React.Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={OpenModalDemand}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99,
        }}
        onClose={handleCloseModalDemand}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <ValidatorForm onSubmit={(e: any) => handleSubmit(e)}>
          <Fade in={OpenModalDemand}>
            <BoxSendEmail>
              <h2>Realizar cobrança de documentos</h2>

              <div style={{ margin: 10 }}>
                Você pode utilizar as tags: <br />
                <ul>
                  <li>
                    <b>[documentos]</b> para mencionar os nomes dos documentos.
                </li>
                  <li>
                    <b>[fornecedor]</b> para mencionar o nome do fornecedor.
                </li>
                  <li>
                    <b>[descricao]</b> para mencionar a descrição dos documentos.
                </li>
                </ul>
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id='email-subject'
                    label="Assunto"
                    type="text"
                    autoFocus={true}
                    fullWidth
                    value={emailCharge.subject}
                    variant="outlined"
                    required={true}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmailCharge({ ...emailCharge, "subject": e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id='email-body'
                    label="Mensagem"
                    type="text"
                    fullWidth
                    value={emailCharge.body}
                    variant="outlined"
                    multiline
                    minRows={8}
                    required={true}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmailCharge({ ...emailCharge, "body": e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <IButton
                    width={90}
                    background="#D12626"
                    type="button"
                    onClick={handleCloseModalDemand}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </IButton>
                  <IButton
                    width={90}
                    background="#52D126"
                    type="submit"
                    style={{ marginRight: 10 }}
                  >
                    Enviar
                  </IButton>
                </Grid>
              </Grid>
            </BoxSendEmail>
          </Fade>
        </ValidatorForm>
      </Modal>
      <Container background="#E2E4E6">
        <ValidatorForm onSubmit={(e: any) => handleSubmitFilter(e)}>
          {!isLoadingDocumentType && !isLoading && (
            <>
              <Grid container spacing={id === "all" ? 3 : 4}>
                <Grid item xs={3}>
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
                  >
                    <InputLabel id="c">Filtro de Status</InputLabel>
                    <Select
                      labelId="c"
                      label="Filtro de Status"
                      inputProps={{ "aria-label": "Without label" }}
                      variant="outlined"
                      value={filterStatus}
                      fullWidth={true}
                      onChange={(e: any) => handleFilterStatusDocuments(e)}
                    >
                      <MenuItem value="99">Todos</MenuItem>
                      <MenuItem value="1">Aprovados</MenuItem>
                      <MenuItem value="0">Pendente Fornecedor</MenuItem>
                      <MenuItem value="2">Vencidos</MenuItem>
                      <MenuItem value="3">Reprovados</MenuItem>
                      <MenuItem value="4">Pendente Central</MenuItem>
                      <MenuItem value="5">Faltantes</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
                  >
                    <InputLabel id="filterTypeLabel">
                      Filtro de Tipos
                    </InputLabel>
                    <Select
                      label="Filtro de Tipos"
                      labelId="filterTypeLabel"
                      inputProps={{ "aria-label": "Without label" }}
                      variant="outlined"
                      value={typesFilter}
                      fullWidth={true}
                      multiple
                      onChange={(e: any) => handleChangeTypeFilter(e)}
                      renderValue={(selected) => (selected as string[]).join(", ")}
                    >
                      {listDocumentTypes?.map((type) => (
                        <MenuItem key={type.id} value={type.name}>
                          <Checkbox
                            name={`check-${type.name}`}
                            checked={checksTypesFilter.indexOf(type.name) !== -1}
                          />
                          <ListItemText primary={type.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {id === "all" && (
                  <Grid item xs={12} sm={2}>
                    <FormControl
                      variant="outlined"
                      style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
                    >
                      <Autocomplete
                        id="filterProvider"
                        options={listProviders}
                        getOptionLabel={(element: Provider) => element?.name}
                        onInputChange={(event: any) => setProviderFilterInput(event.target.value)}
                        onChange={(event: any, newEvent: any) =>
                          handleOnChangeFilterProvider(event, newEvent)
                        }
                        loading={true}
                        renderInput={(element) => (
                          <TextField
                            {...element}
                            label="Filtro de Fornecedores"
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={3}>
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
                  >
                    {ButtonCobrar()}
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}
          {isLoading && (
            <div style={{ textAlign: "center" }}>
              <CircularProgress size={25} />
            </div>
          )}
          {!isLoading && !isLoadingDocumentType && renderListDocument}
        </ValidatorForm>
      </Container>
    </React.Fragment>
  );
};

export default DocumentList;
